<template>
    <div class="flex flex-col items-center gap-1.5 text-white min-h-32">
        <span class="text-xs uppercase font-bold text-zinc-500">{{ $t('segments_game.current_target') }}</span>
        <span class="text-6xl font-bold leading-13 pt-1">{{ targetLabel }}</span>
        <span v-if="showHits" class="text-xs text-zinc-500 uppercase font-bold">
            {{ $t('segments_game.hits_progress', { current: targetHits, total: hitsPerTarget }) }}
        </span>
        <span v-if="totalRounds > 1" class="text-xs text-zinc-500 uppercase font-bold">
            {{ $t('segments_game.round_progress', { current: currentRound, total: totalRounds }) }}
        </span>

        <div v-if="showNext && nextLabels.length" class="flex flex-col items-center text-sm gap-1">
            <span class="uppercase font-bold">{{ $t('segments_game.next_label') }}</span>
            <div class="flex divide-x-2 divide-zinc-700">
                <span v-for="(label, index) in nextLabels" :key="index" class="font-semibold px-2">
                    {{ label }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { DART_TYPES } from '@/constants/dartTypes.js'

export default {
    name: 'SegmentsCurrentTargetText',
    props: {
        // The current target segment ({ type, number }) or null.
        targetSegment: {
            type: Object,
            default: null,
        },
        // Hits already landed on the current target.
        targetHits: {
            type: Number,
            default: 0,
        },
        hitsPerTarget: {
            type: Number,
            default: 1,
        },
        // The full ordered segment list, to read the upcoming targets from.
        segments: {
            type: Array,
            default: () => [],
        },
        // Index of the current target within segments.
        currentIndex: {
            type: Number,
            default: 0,
        },
        // Show the "Next" upcoming targets row (Race mode). Hidden in Points mode.
        showNext: {
            type: Boolean,
            default: true,
        },
        // Show only the target number, dropping the S/D/T multiplier (Points mode,
        // where any part of the number scores).
        numberOnly: {
            type: Boolean,
            default: false,
        },
        // Current round / total rounds (Points + Rounds mode). The round line only
        // shows when totalRounds > 1.
        currentRound: {
            type: Number,
            default: 1,
        },
        totalRounds: {
            type: Number,
            default: 1,
        },
    },
    computed: {
        targetLabel() {
            if (this.numberOnly) {
                return this.targetSegment ? String(this.targetSegment.number) : '—'
            }
            return this.segmentLabel(this.targetSegment)
        },
        showHits() {
            return this.hitsPerTarget > 1 && this.targetHits < this.hitsPerTarget
        },
        // Labels for the next two targets after the current one.
        nextLabels() {
            return this.segments
                .slice(this.currentIndex + 1, this.currentIndex + 3)
                .map((segment) => this.segmentLabel(segment))
        },
    },
    methods: {
        segmentLabel(segment) {
            if (!segment) return '—'
            if (segment.type === DART_TYPES.BULL || segment.type === DART_TYPES.OUTER_BULL) {
                return segment.type
            }
            return `${segment.type}${segment.number}`
        },
    },
}
</script>
